export class RedirectHelper {
  public constructor(
    private _loginUrl: string,
    private _logoutUrl: string,
    private _window: Window
  ) {}

  public toLoginPage() {
    this._window.location.href = this._loginUrl
  }

  /* toLogoutPage is also being used as a means of toHomePage after logout is complete. */
  public toLogoutPage(replacementData: {[key: string]: string} = {}) {
    const url = Object.keys(replacementData).reduce((_url, replacementKey) => {
      return _url.replace(`${replacementKey}`, replacementData[replacementKey])
    }, this._logoutUrl)
    this._window.location.href = url
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/redirect/redirect.helper.ts